import { render, staticRenderFns } from "./TravellerMetrics.vue?vue&type=template&id=0ca82296&lang=pug&"
import script from "./TravellerMetrics.vue?vue&type=script&lang=js&"
export * from "./TravellerMetrics.vue?vue&type=script&lang=js&"
import style0 from "./TravellerMetrics.vue?vue&type=style&index=0&id=0ca82296&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports